/** Причина загрузки истории сообщений, совпадает с сегментом ключа телеметрии chats.messages-get.{reason} */
export enum EMessagesLoadReason {
  /* загрузка страницы истории сообщений */
  Regular = 'regular',
  /* синхронизация сообщений по хешу rowVersions */
  Sync = 'sync',
  /* догрузка истории при переходе к исходному сообщению реплая */
  ReplyScroll = 'reply-scroll',
}
